module.exports = __webpack_public_path__ + "static/media/pi-weather.83f9b9ad.jpg";